import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getStoreRedemptionLedger } from "../../services/api";

const emptyTotals = {
    total_order_amount: 0,
    total_discount: 0,
    total_discountOwner: 0,
    total_discountCust: 0,
};

// args: { perPage, page, filters }  (filters = payload built in StorePanelHome.buildPayload)
export const fetchStoreLedger = createAsyncThunk(
    "storeLedger/fetch",
    async ({ perPage = 25, page = 1, filters = {} } = {}, { rejectWithValue }) => {
        try {
            const res = await getStoreRedemptionLedger(perPage, page, filters);
            return res?.data || {};
        } catch (error) {
            return rejectWithValue(error?.message || "Unable to load store transactions");
        }
    }
);

const initialState = {
    rows: [],
    totals: emptyTotals,
    loading: false,
    error: null,
    currentPage: 1,
    totalPages: 1,
    total: 0,
    from: 0,
    to: 0,
    requestId: null, // only the latest request may write results (avoids stale overwrites)
};

const storeLedgerSlice = createSlice({
    name: "storeLedger",
    initialState,
    reducers: {
        resetStoreLedger: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStoreLedger.pending, (state, action) => {
                state.loading = true;
                state.error = null;
                state.requestId = action.meta.requestId;
            })
            .addCase(fetchStoreLedger.fulfilled, (state, action) => {
                if (state.requestId !== action.meta.requestId) return;
                const r = action.payload?.redemptions || {};
                state.loading = false;
                state.rows = Array.isArray(r.data) ? r.data : [];
                state.totals = { ...emptyTotals, ...(action.payload?.totals || {}) };
                state.currentPage = r.current_page || 1;
                state.totalPages = r.last_page || 1;
                state.total = r.total || 0;
                state.from = r.from || 0;
                state.to = r.to || 0;
            })
            .addCase(fetchStoreLedger.rejected, (state, action) => {
                if (state.requestId !== action.meta.requestId) return;
                state.loading = false;
                state.error = action.payload || action.error?.message || "Something went wrong";
            });
    },
});

export const { resetStoreLedger } = storeLedgerSlice.actions;
export default storeLedgerSlice.reducer;